import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import MaUTable from '@material-ui/core/Table';

const ReactTable = ({ tableProps, children }) => {
  return (
    <>
      <div>
        <TableContainer component={Paper}>
          <MaUTable {...tableProps}>{children}</MaUTable>
        </TableContainer>
      </div>
    </>
  );
};

ReactTable.defaultProps = {
  children: {},
};

ReactTable.propTypes = {
  tableProps: PropTypes.any.isRequired,
  children: PropTypes.any,
};

export default ReactTable;
